import React from "react";
import TextareaAutosize from "react-textarea-autosize";

import { TextAreaContainer } from "./styled.js";

const TextArea = (props) => {
  return (
    <TextAreaContainer>
      <div className="textarea">
        <TextareaAutosize
          {...props}
        />

        {props?.maxLength && (
          <span>
            {props?.value?.length || 0} / {props?.maxLength} caracteres
          </span>
        )}
      </div>
    </TextAreaContainer>
  );
};

export default TextArea;
